<template>
  <div class="container container-luc-hao">
    <section :id="isModeTyping ? 'form-input' : 'duong-so'">
      <router-link :to="{name: 'LucHao'}">
        <h1 class="title">Lục Hào</h1>
      </router-link>
      <form-input v-if="isModeTyping" @input="setData"/>
    </section>
    <section style="padding-bottom: 30px">
      <div ref="printMe" id="printMe" class="index" style="display: none">
        <div class="container-fluid">
          <div v-if="al.hour" class="row">
            <div class="col top_block color_blue">
              <div class="title_header h3">
                <span class="title1">Thăng Long Dịch Số</span>
              </div>
              <p>
                <span class="float-left">Thời gian:</span>
                <span>{{ `${hour}:${minute || '00'}` }} - </span>
                <span>{{ `${day}/${month}/${year}` }}</span>
                |
                <span>Giờ {{ al.hour.name }}, Ngày {{ al.day.name }}, Tháng {{ al.month.name }}, Năm {{ al.year.name }}</span>
              </p>
              <div class="column d-flex p-0">
                <p>
                  <span class="float-left">Tiết khí: </span>
                  <span class="font-weight-bold">{{ alTk.tk.name }}</span>
                </p>
                <p style="margin-left: 15px; margin-right: 15px; min-width: 0;">
                  <span>|</span>
                </p>
                <p style="margin-left: 10px">
                  <span>Nhật thần: </span>
                  <span class="font-weight-bold">{{ nhatThan.name }} - {{ nhatThan.nguhanh }}</span>
                </p>
                <p style="margin-left: 15px; margin-right: 15px; min-width: 0;">
                  <span>|</span>
                </p>
                <p>
                  <span>Nguyện lệnh: </span>
                  <span class="font-weight-bold">{{ nguyetKien.name }} - {{ nguyetKien.nguhanh }}</span>
                </p>
              </div>
              <p>
                <span class="float-left">Phương pháp:</span>
                <span class="font-weight-bold">{{ isGieoQue ? 'Lục Hào' : 'Seri tiền (' + seri + ')' }}</span>
              </p>
              <p>
                <span class="float-left">Viêc cần xem: </span>
                <span class="font-weight-bold">{{ typeXem }}</span>
              </p>
              <p style="color: #0e0ee5;font-style: italic;">
                facebook.com/groups/thanglongdichso
              </p>
            </div>
            <div class="col-2 img-block align-self-center">
              <img width="80" src="@/assets/img/logo_dichso.jpg" alt="">
              <div class="link-web">https://thanglongdichso.com</div>
            </div>
          </div>
          <hr class="br-2">
          <div class="row justify-content-around">
            <div class="column column-left">
              <div class="ho_ly">
                <div class="title-top h4">{{ quegoc.names ? quegoc.names.toString() : ''}}</div>
                <div class="logo">
                  <span
                    v-for="(value, index) in (quegoc.lines ? quegoc.refinedLines : [])"
                    :key="`column-left` + index"
                    :class="{'c_1': value, 'c_2': !value, 'bg-red': changeLines[index]}"
                  />
                </div>
                <div class="title-bottom h4">{{ getHoQue(quegoc) }}</div>
              </div>
            </div>
            <div class="column column-right">
              <div class="ho_ly">
                <div class="title-top h4">{{ quebien.names ? quebien.names.toString() : '' }}</div>
                <div class="logo">
                  <span
                    v-for="(value, index) in (quebien.lines ? quebien.refinedLines : [])"
                    :key="`column-right` + index"
                    :class="{'c_1': value, 'c_2': !value, 'bg-red': changeLines[index]}"
                  />
                </div>
                <div class="title-bottom h4">{{ getHoQue(quebien) }}</div>
              </div>
            </div>
          </div>
          <hr>
          <div class="d-flex justify-content-aroundx table-box">
            <div class="col-left">
              <div class="title_block h5">
                {{ quegoc.image }}
              </div>
              <!-- table 1 -->
              <table>
                <tr style="border-left-color: transparent;">
                  <th>Hào</th>
                  <th>T/U</th>
                  <th>Lục Thân</th>
                  <th>Chi</th>
                  <th>P.Thần</th>
                  <th>T.K</th>
                  <th>V-S</th>
                  <th>T.S</th>
                </tr>
                <tr
                  v-for="(value, index) in quegoc.refinedLines"
                  :key="`quegoc-table1` + index"
                  :class="{'bg-red-opacity text-red ': changeLines[index], 'bg-pink-opacity text-pink': !changeLines[index] && dataQue.amdong === quegoc.diachi[index], 'font-weight-bold': changeLines[index] || dataQue.amdong === quegoc.diachi[index] }"
                  style="border-left-color: transparent;"
                >
                  <td>
                    <span :class="{'c_1': value, 'c_2': !value, 'bg-red': changeLines[index]}"/>
                  </td>
                  <td class="font-weight-bold">
                    {{ [index + 6, (index + 6)  %  6].includes(quegoc.the) ? 'T' : ([index + 6, (index + 6)  %  6].includes(quegoc.ung) ? 'U': '') }}
                  </td>
                  <td class="float-lucthan">{{ quegoc.lucthan[index] }}</td>
                  <td :class="quegoc.colorNguHanh[index]" class="float-chi">{{ quegoc.diachi[index] }}</td>
                  <td :class="`color_${quegoc.phucThanNguHanh[index]}`">{{ quegoc.phucthan && quegoc.phucthan[index] ? `${quegoc.phucThanLucThan[index]}-${quegoc.phucthan[index]}` : '-' }}</td>
                  <td>{{ quegoc.tk[index] ? 'K' : '-' }}</td>
                  <td>{{ quegoc.vuongsuy[index] }}</td>
                  <td>{{ quegoc.ts[index] }}</td>
                </tr>
              </table>
              <!-- table 2 -->
              <table>
                <tr style="border-left-color: transparent;">
                  <th>Hào</th>
                  <th>Q.Thần</th>
                  <th>Lộc</th>
                  <th>Mã</th>
                  <th>Quý</th>
                  <th>Đào</th>
                </tr>
                <tr
                  v-for="(value, index) in quegoc.diachi"
                  :key="`quegoc-table2` + index"
                  :class="{'bg-red-opacity text-red ': changeLines[index], 'bg-pink-opacity text-pink': !changeLines[index] && dataQue.amdong === quegoc.diachi[index], 'font-weight-bold': changeLines[index] || dataQue.amdong === quegoc.diachi[index] }"
                  style="border-left-color: transparent;"
                >
                  <td :class="quegoc.colorNguHanh[index]" class="float-canchi">{{ quegoc.thiencan[index] }}.{{ value }}</td>
                  <td>{{ quegoc.quaithan === value ? 'QT' : '-' }}</td>
                  <td>{{ dataQue.loc.includes(value) ? 'L' : '-' }}</td>
                  <td>{{ dataQue.ma.includes(value) ? 'M' : '-' }}</td>
                  <td>{{ dataQue.quy.includes(value) ? 'Q' : '-' }}</td>
                  <td>{{ dataQue.dao.includes(value) ? 'Đ' : '-' }}</td>
                </tr>
              </table>
            </div>
            <div class="col-right">
              <div class="title_block h5">
                {{ quebien.image }}
              </div>
              <!-- table 1 -->
              <table>
                <tr style="border-right-color: transparent;">
                  <th>Hào</th>
                  <th>Lục Thân</th>
                  <th>Chi</th>
                  <th>L.Thú</th>
                  <th>T.K</th>
                  <th>V-S</th>
                  <th>T.S</th>
                </tr>
                <tr
                  v-for="(value, index) in quebien.refinedLines"
                  :key="`quebien-table1` + index"
                  :class="{'bg-red-opacity text-red font-weight-bold': changeLines[index]}"
                  style="border-right-color: transparent;"
                >
                  <td>
                    <span :class="{'c_1': value, 'c_2': !value, 'bg-red': changeLines[index]}"/>
                  </td>
                  <td class="float-lucthan">{{ quebien.lucthan[index] }}</td>
                  <td :class="quebien.colorNguHanh[index]" class="float-chi">{{ quebien.diachi[index] }}</td>
                  <td :class="lucthu.color[index]">{{ lucthu.name[index] }}</td>
                  <td>{{ quebien.tk[index] ? 'K' : '-' }}</td>
                  <td>{{ quebien.vuongsuy[index] }}</td>
                  <td>{{ quebien.ts[index] }}</td>
                </tr>
              </table>
              <!-- table 2 -->
              <table>
                <tr style="border-right-color: transparent;">
                  <th>Hào</th>
                  <th>Lộc</th>
                  <th>Mã</th>
                  <th>Quý</th>
                  <th>Đào</th>
                </tr>
                <tr
                  v-for="(value, index) in quebien.diachi"
                  :key="`quebien-table2` + index"
                  :class="{'bg-red-opacity text-red font-weight-bold': changeLines[index]}"
                  style="border-right-color: transparent;"
                >
                  <td :class="quebien.colorNguHanh[index]" class="float-canchi">{{ quebien.thiencan[index] }}.{{ value }}</td>
                  <td>{{ dataQue.loc.includes(value) ? 'L' : '-' }}</td>
                  <td>{{ dataQue.ma.includes(value) ? 'M' : '-' }}</td>
                  <td>{{ dataQue.quy.includes(value) ? 'Q' : '-' }}</td>
                  <td>{{ dataQue.dao.includes(value) ? 'Đ' : '-' }}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="img-output">
        <img v-if="!isModeTyping && output" :src="output" style="margin: 3px;width: 100%;"/>
      </div>
    </section>
  </div>
</template>

<script>
import { anLucHao } from '../utils/luchao/luchao'
import FormInput from '../components/luchao/FormInput'
import domtoimage from 'dom-to-image-more'

export default {
  name: 'LucHao',
  components: {
    FormInput
  },
  data () {
    return {
      isModeTyping: true,
      typeXem: null,
      minute: null,
      hour: null,
      day: null,
      month: null,
      year: null,
      gieoque: [],
      isGieoQue: false,
      isHoaTho: true,
      seri: null,
      ketqua: {},
      output: null
    }
  },
  computed: {
    nhatThan () {
      return this.ketqua.nhatThan ?? {}
    },
    nguyetKien () {
      return this.ketqua.nguyetKien ?? {}
    },
    dataQue () {
      return this.ketqua.dataQue ?? {}
    },
    quegoc () {
      return this.dataQue.from ?? {}
    },
    quebien () {
      return this.dataQue.to ?? {}
    },
    lucthu () {
      return this.dataQue.lucthu ?? {}
    },
    changeLines () {
      return this.dataQue?.changeLines ?? []
    },
    al () {
      return this.ketqua.al ?? {}
    },
    alTk () {
      return this.ketqua.alTk ?? {}
    }
  },
  methods: {
    setData ({ typeXem, hour, day, month, year, gieoque, seri, isGieoQue, isHoaTho }) {
      this.typeXem = typeXem
      this.hour = hour
      this.day = day
      this.month = month
      this.year = year
      this.gieoque = gieoque
      this.isModeTyping = false
      this.isGieoQue = isGieoQue
      this.isHoaTho = isHoaTho
      this.seri = seri
      if (isGieoQue) {
        const curLine = this.gieoque.map((d) => d.amduong).reverse()
        const changeLines = this.gieoque.map((d) => d.dong | 0).reverse()
        this.ketqua = anLucHao(parseInt(day, 10), parseInt(month, 10), parseInt(year, 10), hour, 0, isHoaTho, null, curLine, changeLines)
      } else {
        this.ketqua = anLucHao(parseInt(day, 10), parseInt(month, 10), parseInt(year, 10), hour, 0, isHoaTho, seri)
      }
      this.isModeTyping = true
      this.print()
    },
    async print () {
      const el = this.$refs.printMe
      const scale = 2.5
      const options = {
        style: {
          display: 'block',
          transform: `scale(${scale}, ${scale})`,
          transformOrigin: 'top center',
          width: '860px',
          height: '1000px'
        },
        width: 860 * scale,
        height: 930 * scale
      }
      domtoimage.toJpeg(el, options)
        .then((dataUrl) => {
          this.output = dataUrl
          this.isModeTyping = false
        })
        .catch(function (error) {
          this.isModeTyping = false
          console.error('oops, something went wrong!', error)
        })
    },
    getHoQue (que) {
      let hoQue = `Họ ${que.hoQueName}`
      if (que.lucxung) {
        hoQue += ' (Lục xung)'
      } else if (que.luchop) {
        hoQue += ' (Lục hợp)'
      } else if (que.quyhon) {
        hoQue += ' (Quy hồn)'
      } else if (que.duhon) {
        hoQue += ' (Du hồn)'
      }
      return hoQue
    }
  }
}
</script>

<style scoped src="../assets/css/luchao.css" />
<style scoped src="../assets/css/bootstrap2.min.css" />

<style scoped>
  svg {
    background-color: white;
  }
  .text-red {
    color: red;
  }
  .col {
    position: relative;
    width: 100%;
    min-height: 1px;
    padding-right: 10px;
    padding-left: 15px;
  }
</style>
